import { EnvCode, getSiteEnv } from '@tencent/iegsp-common/tools/env';

export interface WbpTodoMenuItem {
  /** 菜单唯一标识，对应后端返回的 key */
  key: string;
  /** 菜单显示名称 */
  label: string;
  /** WBP 外网路由路径 */
  path: string;
  /** 待办数量 */
  count: number;
}

const WBP_DOMAIN_MAP: Record<string, string> = {
  [EnvCode.test]: 'http://test.wbp.qq.com',
  [EnvCode.prod]: '//idea.waibao.qq.com',
};

export const getWbpDomain = (): string => {
  const env = getSiteEnv();
  return WBP_DOMAIN_MAP[env] || WBP_DOMAIN_MAP[EnvCode.prod];
};

/** WBP 菜单配置 — key 待后端接口确认后对齐 */
export const WBP_MENU_CONFIG: { key: string; label: string; path: string }[] = [
  { key: 'system_bulletin_index', label: $t('管理公告'), path: '/system/bulletin/index' },
  { key: 'system_bulletin_recruit', label: $t('招募公告'), path: '/system/bulletin/recruit' },
  { key: 'system_bulletin_system', label: $t('系统公告'), path: '/system/bulletin/system' },
  { key: 'system_price_answer', label: $t('报价'), path: '/system/price/answer' },
  { key: 'system_price_testAnswer', label: $t('测试单报价'), path: '/system/price/testAnswer' },
  { key: 'system_query_await-mail', label: $t('未提交发票'), path: '/system/query/await-mail' },
  { key: 'system_order_distribute', label: $t('订单接收'), path: '/system/order/distribute' },
  { key: 'system_order_fabrication', label: $t('制作及交付'), path: '/system/order/fabrication' },
  { key: 'system_assess_confirm', label: $t('商务确认'), path: '/system/assess/confirm' },
  { key: 'system_contract_stamp', label: $t('签章权限'), path: '/system/contract/stamp' },
  { key: 'system_contract_sign', label: $t('签署合同'), path: '/system/contract/sign' },
];
